import { IconButton } from '@breathelife/mui';

import styled from '../../Styles/themed-styled-components';

export const StyledIconButton = styled(IconButton)`
  &:focus:not(:active) {
    border: 2px solid ${(props) => props.theme.colors.tertiary.default} !important;
  }
`;
